// General Settings
import * as api from "../api";

// Login
export const LoginCall = async (phone, password) => {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_API_URL}${api.Login}`,
      {
        method: "post",
        body: JSON.stringify({
          phone,
          password,
        }),
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    if (!response.ok) {
      return { status: false };
    } else {
      const data = await response.json();
      // console.log(data.token)
      localStorage.setItem("tokenm", data.token);
      console.log("[tokenm]", localStorage.getItem("tokenm"));
      localStorage.setItem("data", "data1");

      return data;
    }
  } catch (error) {
    console.error(error);
    return { status: false };
  }
};

// const str = localStorage.getItem("data");

const tokenStr = localStorage.getItem("tokenm");

export const loginuserdata = JSON.parse(localStorage.getItem("userdata"));

export const userId = loginuserdata?.user?.id;

// Diagnosis type
export const DiagnosisTypeList = async () => {
  console.log(localStorage.getItem("tokenStr"));
  console.log(tokenStr);
  try {
    const res = await fetch(
      `${process.env.REACT_APP_API_URL}${api.DiagnosisType}`,
      {
        method: "get",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${tokenStr}`,
        },
      }
    );
    console.log(res);
    if (!res.ok) {
      return { status: false };
    }
    const data = await res.json();
    return data;
  } catch (error) {
    // Handle the error
    console.error(error);
    return { status: false };
  }
};

// ------------------- Add Diagnosis Type -------------

export const CreateDiagnosisType = async (DiagnosisType) => {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_API_URL}${api.AddDiagnosisType}`,
      {
        method: "post",
        body: JSON.stringify(DiagnosisType),
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${tokenStr}`,
        },
      }
    );
    if (!response.ok) {
      return { status: false };
    } else {
      const data = await response.json();
      return data;
    }
  } catch (error) {
    console.error(error);
    return { status: false };
  }
};

// ------------------- Update Diagnosis Type -------------

export const UpdateDiagnosisType = async (DiagnosisType) => {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_API_URL}${api.UpdateDiagnosisType}`,
      {
        method: "PUT",
        body: JSON.stringify(DiagnosisType),
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${tokenStr}`,
        },
      }
    );
    if (!response.ok) {
      return { status: false };
    } else {
      const data = await response.json();
      return data;
    }
  } catch (error) {
    console.error(error);
    return { status: false };
  }
};

// -------------------------- DiagnosisType Delete API ----------
export const DeleteDiagnosisType = async (id) => {
  try {
    const res = await fetch(
      `${process.env.REACT_APP_API_URL}${api.DeleteDiagnosisType}`,
      {
        method: "delete",
        body: JSON.stringify({
          id: id.toString(),
        }),
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${tokenStr}`,
        },
      }
    );
    if (!res.ok) {
      return { status: false };
    }
    const data = await res.json();
    return data;
  } catch (error) {
    // Handle the error
    console.error(error);
    return { status: false };
  }
};

// -----------------------------------------------  Doctor Department list API ------------

export const DoctorDepartmentList = async () => {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_API_URL}${api.DoctorDepartmentList}`,
      {
        method: "get",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${tokenStr}`,
        },
      }
    );
    if (!response.ok) {
      return { status: false };
    } else {
      const data = await response.json();
      return data;
    }
  } catch (error) {
    console.error(error);
    return { status: false };
  }
};

// ------------------- Add Doctor Department  -------------

export const CreateDoctorDepartment = async (department) => {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_API_URL}${api.CreateDoctorDepartment}`,
      {
        method: "post",
        body: JSON.stringify(department),
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${tokenStr}`,
        },
      }
    );
    if (!response.ok) {
      return { status: false };
    } else {
      const data = await response.json();
      return data;
    }
  } catch (error) {
    console.error(error);
    return { status: false };
  }
};

// -------------------  Update  Doctor Department  -------------

export const UpdateDoctorDepartment = async (department) => {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_API_URL}${api.UpdateDoctorDepartment}`,
      {
        method: "PUT",
        body: JSON.stringify(department),
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${tokenStr}`,
        },
      }
    );
    if (!response.ok) {
      return { status: false };
    } else {
      const data = await response.json();
      return data;
    }
  } catch (error) {
    console.error(error);
    return { status: false };
  }
};

// --------------------------  Doctor Department Delete API ----------

export const DeleteDoctorDepartment = async (id) => {
  try {
    const res = await fetch(
      `${process.env.REACT_APP_API_URL}${api.DeleteDoctorDepartment}`,
      {
        method: "delete",
        body: JSON.stringify({
          id: id.toString(),
        }),
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${tokenStr}`,
        },
      }
    );
    if (!res.ok) {
      return { status: false };
    }
    const data = await res.json();
    return data;
  } catch (error) {
    console.error(error);
    return { status: false };
  }
};

// ------------------- Add Inventory Catagory  -------------

export const CreateInventoryCategory = async (category) => {
  try {
    console.log(category);
    const response = await fetch(
      `${process.env.REACT_APP_API_URL}${api.CreateInventoryCategory}`,
      {
        method: "post",
        body: JSON.stringify(category),
        // body: JSON.stringify({"name": category.toString()}),
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${tokenStr}`,
        },
      }
    );
    if (!response.ok) {
      return { status: false };
    } else {
      const data = await response.json();
      return data;
    }
  } catch (error) {
    console.error(error);
    return { status: false };
  }
};

// -------------------  Update Inventory Catagory  -------------

export const UpdateInventoryCategory = async (category) => {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_API_URL}${api.UpdateInventoryCategory}`,
      {
        method: "PUT",
        body: JSON.stringify(category),
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${tokenStr}`,
        },
      }
    );
    if (!response.ok) {
      return { status: false };
    } else {
      const data = await response.json();
      return data;
    }
  } catch (error) {
    console.error(error);
    return { status: false };
  }
};

// ----------------------------------------------- Inventory Catagory list API ------------

export const InventoryCategoryList = async () => {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_API_URL}${api.InventoryCategoryList}`,
      {
        method: "get",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${tokenStr}`,
        },
      }
    );
    if (!response.ok) {
      return { status: false };
    } else {
      const data = await response.json();
      return data;
    }
  } catch (error) {
    console.error(error);
    return { status: false };
  }
};

// -------------------------- Inventory Category Delete API ----------
export const DeleteInventoryCategory = async (id) => {
  try {
    const res = await fetch(
      `${process.env.REACT_APP_API_URL}${api.DeleteInventoryCategory}`,
      {
        method: "delete",
        body: JSON.stringify({
          id: id.toString(),
        }),
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${tokenStr}`,
        },
      }
    );
    if (!res.ok) {
      return { status: false };
    }
    const data = await res.json();
    return data;
  } catch (error) {
    // Handle the error
    console.error(error);
    return { status: false };
  }
};
// ----------------------------------------------- Add Medical Report Type API ------------

export const CreateMedicalReportType = async (reportype) => {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_API_URL}${api.CreateMedicalReportType}`,
      {
        method: "post",
        body: JSON.stringify(reportype),
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${tokenStr}`,
        },
      }
    );
    if (!response.ok) {
      return { status: false };
    } else {
      const data = await response.json();
      return data;
    }
  } catch (error) {
    console.error(error);
    return { status: false };
  }
};

// ----------------------------------------------- Medical Report Type list API ------------

export const MedicalReportTypeList = async () => {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_API_URL}${api.MedicalReportTypeList}`,
      {
        method: "get",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${tokenStr}`,
        },
      }
    );
    if (!response.ok) {
      return { status: false };
    } else {
      const data = await response.json();
      return data;
    }
  } catch (error) {
    console.error(error);
    return { status: false };
  }
};

// ----------------------------- Medical Report Type edit api ------------------

export const UpdateMedicalReportType = async (reportype) => {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_API_URL}${api.UpdateMedicalReportType}`,
      {
        method: "put",
        body: JSON.stringify(reportype),
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${tokenStr}`,
        },
      }
    );
    if (!response.ok) {
      return { status: false };
    } else {
      const data = await response.json();
      return data;
    }
  } catch (error) {
    console.error(error);
    return { status: false };
  }
};

// -------------------------- Medical Report Type Delete API ----------
export const DeleteMedicalReportType = async (id) => {
  try {
    const res = await fetch(
      `${process.env.REACT_APP_API_URL}${api.DeleteMedicalReportType}`,
      {
        method: "delete",
        body: JSON.stringify({
          id: id.toString(),
        }),
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${tokenStr}`,
        },
      }
    );
    if (!res.ok) {
      return { status: false };
    }
    const data = await res.json();
    return data;
  } catch (error) {
    // Handle the error
    console.error(error);
    return { status: false };
  }
};

// ----------------------------------------------- Pharamcy Catagory list API ------------

export const PharmacyCategoryList = async () => {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_API_URL}${api.PharmacyCategoryList}`,
      {
        method: "get",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${tokenStr}`,
        },
      }
    );
    if (!response.ok) {
      return { status: false };
    } else {
      const data = await response.json();
      return data;
    }
  } catch (error) {
    console.error(error);
    return { status: false };
  }
};

// ------------------- Add Pharamacy Catagory  -------------

export const CreatePharmacyCategory = async (category) => {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_API_URL}${api.CreatePharmacyCategory}`,
      {
        method: "post",
        body: JSON.stringify(category),
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${tokenStr}`,
        },
      }
    );
    if (!response.ok) {
      return { status: false };
    } else {
      const data = await response.json();
      return data;
    }
  } catch (error) {
    console.error(error);
    return { status: false };
  }
};

// -------------------  Update Pharmacy Catagory   -------------

export const UpdatePharmacyCategory = async (category) => {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_API_URL}${api.UpdatePharmacyCategory}`,
      {
        method: "PUT",
        body: JSON.stringify(category),
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${tokenStr}`,
        },
      }
    );
    if (!response.ok) {
      return { status: false };
    } else {
      const data = await response.json();
      return data;
    }
  } catch (error) {
    console.error(error);
    return { status: false };
  }
};

// -------------------------- Pharamacy Catagory Delete API ----------
export const DeletePharmacyCategory = async (id) => {
  try {
    const res = await fetch(
      `${process.env.REACT_APP_API_URL}${api.DeletePharmacyCategory}`,
      {
        method: "delete",
        body: JSON.stringify({
          id: id.toString(),
        }),
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${tokenStr}`,
        },
      }
    );
    if (!res.ok) {
      return { status: false };
    }
    const data = await res.json();
    return data;
  } catch (error) {
    // Handle the error
    console.error(error);
    return { status: false };
  }
};

// ----------------------------------------------- Staff Catagory list API ------------

export const StaffCategoryList = async () => {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_API_URL}${api.StaffCategoryList}`,
      {
        method: "get",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${tokenStr}`,
        },
      }
    );
    if (!response.ok) {
      return { status: false };
    } else {
      const data = await response.json();
      return data;
    }
  } catch (error) {
    console.error(error);
    return { status: false };
  }
};

// ------------------- Add Staff Catagory  -------------

export const CreateStaffCategory = async (category) => {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_API_URL}${api.CreateStaffCategory}`,
      {
        method: "post",
        body: JSON.stringify(category),
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${tokenStr}`,
        },
      }
    );
    if (!response.ok) {
      return { status: false };
    } else {
      const data = await response.json();
      return data;
    }
  } catch (error) {
    console.error(error);
    return { status: false };
  }
};

// -------------------  Update Staff Catagory   -------------

export const UpdateStaffCategory = async (category) => {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_API_URL}${api.UpdateStaffCategory}`,
      {
        method: "PUT",
        body: JSON.stringify(category),
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${tokenStr}`,
        },
      }
    );
    if (!response.ok) {
      return { status: false };
    } else {
      const data = await response.json();
      return data;
    }
  } catch (error) {
    console.error(error);
    return { status: false };
  }
};

// -------------------------- Staff Catagory Delete API ----------

export const DeleteStaffCategory = async (id) => {
  try {
    const res = await fetch(
      `${process.env.REACT_APP_API_URL}${api.DeleteStaffCategory}`,
      {
        method: "delete",
        body: JSON.stringify({
          id: id.toString(),
        }),
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${tokenStr}`,
        },
      }
    );
    if (!res.ok) {
      return { status: false };
    }
    const data = await res.json();
    return data;
  } catch (error) {
    // Handle the error
    console.error(error);
    return { status: false };
  }
};

// -------------------------- DiagnosisType id list API ----------
export const DiagnosisList = async () => {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_API_URL}${api.DiagnosisList}`,
      {
        method: "get",

        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${tokenStr}`,
        },
      }
    );
    if (!response.ok) {
      return { status: false };
    } else {
      const data = await response.json();
      return data;
    }
  } catch (error) {
    console.error(error);
    return { status: false };
  }
};

// ----------------------------------------------- Add Diagnosis API ------------

export const CreateDiagnosis = async (diagnosis) => {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_API_URL}${api.CreateDiagnosis}`,
      {
        method: "post",
        body: JSON.stringify(diagnosis),
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${tokenStr}`,
        },
      }
    );
    if (!response.ok) {
      return { status: false };
    } else {
      const data = await response.json();
      return data;
    }
  } catch (error) {
    console.error(error);
    return { status: false };
  }
};

// ------------------- Update Diagnosis  -------------

export const UpdateDiagnosis = async (diagnosis) => {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_API_URL}${api.UpdateDiagnosis}`,
      {
        method: "PUT",
        body: JSON.stringify(diagnosis),
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${tokenStr}`,
        },
      }
    );
    if (!response.ok) {
      return { status: false };
    } else {
      const data = await response.json();
      return data;
    }
  } catch (error) {
    console.error(error);
    return { status: false };
  }
};

// -------------------------- Diagnosis Delete API ----------
export const DeleteDiagnosis = async (id) => {
  try {
    const res = await fetch(
      `${process.env.REACT_APP_API_URL}${api.DeleteDiagnosis}`,
      {
        method: "delete",
        body: JSON.stringify({
          id: id.toString(),
        }),
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${tokenStr}`,
        },
      }
    );
    if (!res.ok) {
      return { status: false };
    }
    const data = await res.json();
    return data;
  } catch (error) {
    // Handle the error
    console.error(error);
    return { status: false };
  }
};

// -------------------------- DiagnosisType id list API ----------
export const TreatmentPlanList = async () => {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_API_URL}${api.TreatmentPlanList}`,
      {
        method: "get",

        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${tokenStr}`,
        },
      }
    );
    if (!response.ok) {
      return { status: false };
    } else {
      const data = await response.json();
      return data;
    }
  } catch (error) {
    console.error(error);
    return { status: false };
  }
};

// ----------------------------------------------- Add Diagnosis API ------------

export const CreateTreatmentPlan = async (diagnosis) => {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_API_URL}${api.CreateTreatmentPlan}`,
      {
        method: "post",
        body: JSON.stringify(diagnosis),
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${tokenStr}`,
        },
      }
    );
    if (!response.ok) {
      return { status: false };
    } else {
      const data = await response.json();
      return data;
    }
  } catch (error) {
    console.error(error);
    return { status: false };
  }
};

// ------------------- Update Diagnosis  -------------

export const UpdateTreatmentPlan = async (diagnosis) => {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_API_URL}${api.UpdateTreatmentPlan}`,
      {
        method: "PUT",
        body: JSON.stringify(diagnosis),
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${tokenStr}`,
        },
      }
    );
    if (!response.ok) {
      return { status: false };
    } else {
      const data = await response.json();
      return data;
    }
  } catch (error) {
    console.error(error);
    return { status: false };
  }
};

// -------------------------- Treatment Plan Delete API ----------
export const DeleteTreatmentPlan = async (id) => {
  try {
    const res = await fetch(
      `${process.env.REACT_APP_API_URL}${api.DeleteTreatmentPlan}`,
      {
        method: "delete",
        body: JSON.stringify({
          id: id.toString(),
        }),
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${tokenStr}`,
        },
      }
    );
    if (!res.ok) {
      return { status: false };
    }
    const data = await res.json();
    return data;
  } catch (error) {
    // Handle the error
    console.error(error);
    return { status: false };
  }
};

// -------------------------- Treatment Procedure List ----------
export const TreatmentProcedureList = async () => {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_API_URL}${api.TreatmentProcedureList}`,
      {
        method: "get",

        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${tokenStr}`,
        },
      }
    );
    if (!response.ok) {
      return { status: false };
    } else {
      const data = await response.json();
      return data;
    }
  } catch (error) {
    console.error(error);
    return { status: false };
  }
};

// -----------------------------------------------Create Treatment Procedure API ------------

export const CreateTreatmentProcedure = async (diagnosis) => {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_API_URL}${api.CreateTreatmentProcedure}`,
      {
        method: "post",
        body: JSON.stringify(diagnosis),
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${tokenStr}`,
        },
      }
    );
    if (!response.ok) {
      return { status: false };
    } else {
      const data = await response.json();
      return data;
    }
  } catch (error) {
    console.error(error);
    return { status: false };
  }
};

// ------------------- Update Treatment Procedure  -------------

export const UpdateTreatmentProcedure = async (diagnosis) => {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_API_URL}${api.UpdateTreatmentProcedure}`,
      {
        method: "PUT",
        body: JSON.stringify(diagnosis),
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${tokenStr}`,
        },
      }
    );
    if (!response.ok) {
      return { status: false };
    } else {
      const data = await response.json();
      return data;
    }
  } catch (error) {
    console.error(error);
    return { status: false };
  }
};

// -------------------------- Delete Treatment Procedure API ----------
export const DeleteTreatmentProcedure = async (id) => {
  try {
    const res = await fetch(
      `${process.env.REACT_APP_API_URL}${api.DeleteTreatmentProcedure}`,
      {
        method: "delete",
        body: JSON.stringify({
          id: id.toString(),
        }),
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${tokenStr}`,
        },
      }
    );
    if (!res.ok) {
      return { status: false };
    }
    const data = await res.json();
    return data;
  } catch (error) {
    // Handle the error
    console.error(error);
    return { status: false };
  }
};

// -------------------------- Treatment Method List ----------
export const TreatmentMethodList = async () => {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_API_URL}${api.TreatmentMethodList}`,
      {
        method: "get",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${tokenStr}`,
        },
      }
    );
    if (!response.ok) {
      return { status: false };
    } else {
      const data = await response.json();
      return data;
    }
  } catch (error) {
    console.error(error);
    return { status: false };
  }
};

// -----------------------------------------------Create Treatment Method API ------------

export const CreateTreatmentMethod = async (diagnosis) => {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_API_URL}${api.CreateTreatmentMethod}`,
      {
        method: "post",
        body: JSON.stringify(diagnosis),
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${tokenStr}`,
        },
      }
    );
    if (!response.ok) {
      return { status: false };
    } else {
      const data = await response.json();
      return data;
    }
  } catch (error) {
    console.error(error);
    return { status: false };
  }
};

// ------------------- Update Treatment Method  -------------

export const UpdateTreatmentMethod = async (diagnosis) => {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_API_URL}${api.UpdateTreatmentMethod}`,
      {
        method: "PUT",
        body: JSON.stringify(diagnosis),
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${tokenStr}`,
        },
      }
    );
    if (!response.ok) {
      return { status: false };
    } else {
      const data = await response.json();
      return data;
    }
  } catch (error) {
    console.error(error);
    return { status: false };
  }
};

// -------------------------- Delete Treatment Method API ----------
export const DeleteTreatmentMethod = async (id) => {
  try {
    const res = await fetch(
      `${process.env.REACT_APP_API_URL}${api.DeleteTreatmentMethod}`,
      {
        method: "delete",
        body: JSON.stringify({
          id: id.toString(),
        }),
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${tokenStr}`,
        },
      }
    );
    if (!res.ok) {
      return { status: false };
    }
    const data = await res.json();
    return data;
  } catch (error) {
    // Handle the error
    console.error(error);
    return { status: false };
  }
};

// -------------------------- Pharmacy List ----------
export const PharmacyList = async () => {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_API_URL}${api.PharmacyList}`,
      {
        method: "get",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${tokenStr}`,
        },
      }
    );
    if (!response.ok) {
      return { status: false };
    } else {
      const data = await response.json();
      return data;
    }
  } catch (error) {
    console.error(error);
    return { status: false };
  }
};

// -----------------------------------------------Create Pharmacy ------------

export const CreatePharmacy = async (diagnosis) => {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_API_URL}${api.CreatePharmacy}`,
      {
        method: "post",
        body: JSON.stringify(diagnosis),
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${tokenStr}`,
        },
      }
    );
    if (!response.ok) {
      return { status: false };
    } else {
      const data = await response.json();
      return data;
    }
  } catch (error) {
    console.error(error);
    return { status: false };
  }
};

// ------------------- Update Pharmacy  -------------

export const UpdatePharmacy = async (diagnosis) => {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_API_URL}${api.UpdatePharmacy}`,
      {
        method: "PUT",
        body: JSON.stringify(diagnosis),
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${tokenStr}`,
        },
      }
    );
    if (!response.ok) {
      return { status: false };
    } else {
      const data = await response.json();
      return data;
    }
  } catch (error) {
    console.error(error);
    return { status: false };
  }
};

// -------------------------- Delete Pharmacy ----------
export const DeletePharmacy = async (id) => {
  try {
    const res = await fetch(
      `${process.env.REACT_APP_API_URL}${api.DeletePharmacy}`,
      {
        method: "delete",
        body: JSON.stringify({
          id: id.toString(),
        }),
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${tokenStr}`,
        },
      }
    );
    if (!res.ok) {
      return { status: false };
    }
    const data = await res.json();
    return data;
  } catch (error) {
    // Handle the error
    console.error(error);
    return { status: false };
  }
};
// -------------------------- Pharmacy List ----------
export const InventoryList = async () => {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_API_URL}${api.InventoryList}`,
      {
        method: "get",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${tokenStr}`,
        },
      }
    );
    if (!response.ok) {
      return { status: false };
    } else {
      const data = await response.json();
      return data;
    }
  } catch (error) {
    console.error(error);
    return { status: false };
  }
};

// -----------------------------------------------Create Pharmacy ------------

export const CreateInventory = async (diagnosis) => {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_API_URL}${api.CreateInventory}`,
      {
        method: "post",
        body: JSON.stringify(diagnosis),
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${tokenStr}`,
        },
      }
    );
    if (!response.ok) {
      return { status: false };
    } else {
      const data = await response.json();
      return data;
    }
  } catch (error) {
    console.error(error);
    return { status: false };
  }
};

// ------------------- Update Pharmacy  -------------

export const UpdateInventory = async (diagnosis) => {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_API_URL}${api.UpdateInventory}`,
      {
        method: "PUT",
        body: JSON.stringify(diagnosis),
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${tokenStr}`,
        },
      }
    );
    if (!response.ok) {
      return { status: false };
    } else {
      const data = await response.json();
      return data;
    }
  } catch (error) {
    console.error(error);
    return { status: false };
  }
};

// -------------------------- Delete Pharmacy ----------
export const DeleteInventory = async (id) => {
  try {
    const res = await fetch(
      `${process.env.REACT_APP_API_URL}${api.DeleteInventory}`,
      {
        method: "delete",
        body: JSON.stringify({
          id: id.toString(),
        }),
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${tokenStr}`,
        },
      }
    );
    if (!res.ok) {
      return { status: false };
    }
    const data = await res.json();
    return data;
  } catch (error) {
    // Handle the error
    console.error(error);
    return { status: false };
  }
};

// -------------------------- Doctor List ----------
export const DoctorList = async () => {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_API_URL}${api.DoctorList}`,
      {
        method: "get",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${tokenStr}`,
        },
      }
    );
    if (!response.ok) {
      return { status: false };
    } else {
      const data = await response.json();
      return data;
    }
  } catch (error) {
    console.error(error);
    return { status: false };
  }
};

// -----------------------------------------------Create Doctor ------------

export const CreateDoctor = async (doctor) => {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_API_URL}${api.CreateDoctor}`,
      {
        method: "post",
        body: JSON.stringify(doctor),
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${tokenStr}`,
        },
      }
    );
    if (!response.ok) {
      return { status: false };
    } else {
      const data = await response.json();
      return data;
    }
  } catch (error) {
    console.error(error);
    return { status: false };
  }
};

// ------------------- Update  DOctor  -------------

export const UpdateDoctor = async (doctor) => {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_API_URL}${api.UpdateDocor}`,
      {
        method: "PUT",
        body: JSON.stringify(doctor),
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${tokenStr}`,
        },
      }
    );
    if (!response.ok) {
      return { status: false };
    } else {
      const data = await response.json();
      return data;
    }
  } catch (error) {
    console.error(error);
    return { status: false };
  }
};

// -------------------------- Delete  Doctor ----------
export const DeleteDoctor = async (id) => {
  try {
    const res = await fetch(
      `${process.env.REACT_APP_API_URL}${api.DeleteDoctor}`,
      {
        method: "delete",
        body: JSON.stringify({
          id: id.toString(),
        }),
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${tokenStr}`,
        },
      }
    );
    if (!res.ok) {
      return { status: false };
    }
    const data = await res.json();
    return data;
  } catch (error) {
    // Handle the error
    console.error(error);
    return { status: false };
  }
};

// -------------------------- Staff List ----------
export const StaffList = async () => {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_API_URL}${api.StaffList}`,
      {
        method: "get",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${tokenStr}`,
        },
      }
    );
    if (!response.ok) {
      return { status: false };
    } else {
      const data = await response.json();
      return data;
    }
  } catch (error) {
    console.error(error);
    return { status: false };
  }
};

// -----------------------------------------------Create Staff ------------

export const CreateStaff = async (doctor) => {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_API_URL}${api.CreateStaff}`,
      {
        method: "post",
        body: JSON.stringify(doctor),
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${tokenStr}`,
        },
      }
    );
    if (!response.ok) {
      return { status: false };
    } else {
      const data = await response.json();
      return data;
    }
  } catch (error) {
    console.error(error);
    return { status: false };
  }
};

// ------------------- Update  Staff  -------------

export const UpdateStaff = async (doctor) => {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_API_URL}${api.UpdateStaff}`,
      {
        method: "PUT",
        body: JSON.stringify(doctor),
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${tokenStr}`,
        },
      }
    );
    if (!response.ok) {
      return { status: false };
    } else {
      const data = await response.json();
      return data;
    }
  } catch (error) {
    console.error(error);
    return { status: false };
  }
};

// -------------------------- Delete  Staff ----------
export const DeleteStaff = async (id) => {
  try {
    const res = await fetch(
      `${process.env.REACT_APP_API_URL}${api.DeleteStaff}`,
      {
        method: "delete",
        body: JSON.stringify({
          id: id.toString(),
        }),
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${tokenStr}`,
        },
      }
    );
    if (!res.ok) {
      return { status: false };
    }
    const data = await res.json();
    return data;
  } catch (error) {
    // Handle the error
    console.error(error);
    return { status: false };
  }
};

// -------------------------- Patient List ----------
export const PatientList = async () => {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_API_URL}${api.PatientList}`,
      {
        method: "get",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${tokenStr}`,
        },
      }
    );
    if (!response.ok) {
      return { status: false };
    } else {
      const data = await response.json();
      return data;
    }
  } catch (error) {
    console.error(error);
    return { status: false };
  }
};

// -----------------------------------------------Create Patient ------------

export const CreatePatient = async (doctor) => {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_API_URL}${api.CreatePatient}`,
      {
        method: "post",
        body: JSON.stringify(doctor),
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${tokenStr}`,
        },
      }
    );
    if (!response.ok) {
      return { status: false };
    } else {
      const data = await response.json();
      return data;
    }
  } catch (error) {
    console.error(error);
    return { status: false };
  }
};

// ------------------- Update  Patient  -------------

export const UpdatePatient = async (doctor) => {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_API_URL}${api.UpdatePatient}`,
      {
        method: "PUT",
        body: JSON.stringify(doctor),
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${tokenStr}`,
        },
      }
    );
    if (!response.ok) {
      return { status: false };
    } else {
      const data = await response.json();
      return data;
    }
  } catch (error) {
    console.error(error);
    return { status: false };
  }
};

// -------------------------- Delete  Patient ----------
export const DeletePatient = async (id) => {
  try {
    const res = await fetch(
      `${process.env.REACT_APP_API_URL}${api.DeletePatient}`,
      {
        method: "delete",
        body: JSON.stringify({
          id: id.toString(),
        }),
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${tokenStr}`,
        },
      }
    );
    if (!res.ok) {
      return { status: false };
    }
    const data = await res.json();
    return data;
  } catch (error) {
    // Handle the error
    console.error(error);
    return { status: false };
  }
};

// -----------------------------------------------Create GeneralMedicalRecord ------------

export const GeneralMedicalRecord = async (data) => {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_API_URL}${api.GeneralMedicalRecord}`,
      {
        method: "post",
        body: JSON.stringify(data),
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${tokenStr}`,
        },
      }
    );
    if (!response.ok) {
      return { status: false };
    } else {
      const data = await response.json();
      return data;
    }
  } catch (error) {
    console.error(error);
    return { status: false };
  }
};

// -------------------------- General Medical Record List List ----------
export const GeneralMedicalRecordList = async () => {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_API_URL}${api.GeneralMedicalRecordList}`,
      {
        method: "get",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${tokenStr}`,
        },
      }
    );
    if (!response.ok) {
      return { status: false };
    } else {
      const data = await response.json();
      return data;
    }
  } catch (error) {
    console.error(error);
    return { status: false };
  }
};

// TreatmentPlanMapping
export const CreateTreatmentPlanMapping = async (map) => {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_API_URL}${api.CreateTreatmentPlanMapping}`,
      {
        method: "post",
        body: JSON.stringify(map),
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${tokenStr}`,
          "Referrer-Policy": "strict-origin-when-cross-origin",
        },
      }
    );
    if (!response.ok) {
      return { status: false };
    } else {
      const data = await response.json();
      return data;
    }
  } catch (error) {
    console.error(error);
    return { status: false };
  }
};
// TreatmentPlanMappingList
export const TreatmentPlanMappingList = async () => {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_API_URL}${api.TreatmentPlanMappingList}`,
      {
        method: "get",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${tokenStr}`,
        },
      }
    );
    if (!response.ok) {
      return { status: false };
    } else {
      const data = await response.json();
      return data;
    }
  } catch (error) {
    console.error(error);
    return { status: false };
  }
};

// TreatmentPlan Update
export const UpdateTreatmentPlanMapping = async (plan) => {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_API_URL}${api.UpdateTreatmentPlanMapping}`,
      {
        method: "PUT",
        body: JSON.stringify(plan),
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${tokenStr}`,
        },
      }
    );
    if (!response.ok) {
      return { status: false };
    } else {
      const data = await response.json();
      return data;
    }
  } catch (error) {
    console.error(error);
    return { status: false };
  }
};

//Delete TreatmentPlan Mapping

export const DeleteTreatmentPlanMapping = async (id) => {
  try {
    const res = await fetch(
      `${process.env.REACT_APP_API_URL}${api.DeleteTreatmentPlanMapping}`,
      {
        method: "delete",
        body: JSON.stringify({
          id: id.toString(),
        }),
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${tokenStr}`,
        },
      }
    );
    if (!res.ok) {
      return { status: false };
    }
    const data = await res.json();
    return data;
  } catch (error) {
    // Handle the error
    console.error(error);
    return { status: false };
  }
};

// Book an Appoinment

export const CreateAppointment = async (map) => {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_API_URL}${api.CreateAppointment}`,
      {
        method: "post",
        body: JSON.stringify(map),
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${tokenStr}`,
          "Referrer-Policy": "strict-origin-when-cross-origin",
        },
      }
    );
    if (!response.ok) {
      return { status: false };
    } else {
      const data = await response.json();
      return data;
    }
  } catch (error) {
    console.error(error);
    return { status: false };
  }
};

// Appointmnet List
export const AppointmentList = async () => {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_API_URL}${api.AppointmentList}`,
      {
        method: "get",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${tokenStr}`,
        },
      }
    );
    if (!response.ok) {
      return { status: false };
    } else {
      const data = await response.json();
      return data;
    }
  } catch (error) {
    console.error(error);
    return { status: false };
  }
};

// Reschedule Appointment
export const RescheduleAppointment = async (app) => {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_API_URL}${api.RescheduleAppointment}`,
      {
        method: "post",
        body: JSON.stringify(app),
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${tokenStr}`,
          "Referrer-Policy": "strict-origin-when-cross-origin",
        },
      }
    );
    if (!response.ok) {
      return { status: false };
    } else {
      const data = await response.json();
      return data;
    }
  } catch (error) {
    console.error(error);
    return { status: false };
  }
};
// Next Appointment
export const NextAppointment = async (app) => {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_API_URL}${api.NextAppointment}`,
      {
        method: "post",
        body: JSON.stringify(app),
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${tokenStr}`,
          "Referrer-Policy": "strict-origin-when-cross-origin",
        },
      }
    );
    if (!response.ok) {
      return { status: false };
    } else {
      const data = await response.json();
      return data;
    }
  } catch (error) {
    console.error(error);
    return { status: false };
  }
};

// Appointment Status
export const AppointmentStatus = async (sta) => {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_API_URL}${api.AppointmentStatus}`,
      {
        method: "PUT",
        body: JSON.stringify(sta),
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${tokenStr}`,
        },
      }
    );
    if (!response.ok) {
      return { status: false };
    } else {
      const data = await response.json();
      return data;
    }
  } catch (error) {
    console.error(error);
    return { status: false };
  }
};

// Medical Report List
export const MedicalreportList = async (app) => {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_API_URL}${api.MedicalreportList}`,
      {
        method: "post",
        body: JSON.stringify(app),
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${tokenStr}`,
          "Referrer-Policy": "strict-origin-when-cross-origin",
        },
      }
    );
    if (!response.ok) {
      return { status: false };
    } else {
      const data = await response.json();
      return data;
    }
  } catch (error) {
    console.error(error);
    return { status: false };
  }
};

// Create Medical Report

export const CreateMedicalReport = async (formData) => {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_API_URL}${api.CreateMedicalReport}`,
      {
        method: "post",
        body: formData,
        // body: JSON.stringify(app),
        headers: {
          //"Content-Type": "application/json",
          Authorization: `Bearer ${tokenStr}`,
          "Referrer-Policy": "strict-origin-when-cross-origin",
        },
      }
    );
    if (!response.ok) {
      return { status: false };
    } else {
      const data = await response.json();
      return data;
    }
  } catch (error) {
    console.error(error);
    return { status: false };
  }
};

// Delete Medical Report

export const DeleteMedicalReport = async (id) => {
  try {
    const res = await fetch(
      `${process.env.REACT_APP_API_URL}${api.DeleteMedicalReport}`,
      {
        method: "delete",
        body: JSON.stringify({
          id: id.toString(),
        }),
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${tokenStr}`,
        },
      }
    );
    if (!res.ok) {
      return { status: false };
    }
    const data = await res.json();
    return data;
  } catch (error) {
    // Handle the error
    console.error(error);
    return { status: false };
  }
};

// Upcoming Appointments

export const UpcomingAppointmentList = async (date) => {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_API_URL}${api.UpcomingAppointmentList}`,
      {
        method: "post",
        body: JSON.stringify(date),
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${tokenStr}`,
          "Referrer-Policy": "strict-origin-when-cross-origin",
        },
      }
    );
    if (!response.ok) {
      return { status: false };
    } else {
      const data = await response.json();
      return data;
    }
  } catch (error) {
    console.error(error);
    return { status: false };
  }
};

// Scheduled List
export const ScheduledList = async () => {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_API_URL}${api.ScheduledList}`,
      {
        method: "get",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${tokenStr}`,
        },
      }
    );
    if (!response.ok) {
      return { status: false };
    } else {
      const data = await response.json();
      return data;
    }
  } catch (error) {
    console.error(error);
    return { status: false };
  }
};

// Patient Prescription List

export const PatientPrescriptionList = async (id) => {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_API_URL}${api.PatientPrescriptionList}`,
      {
        method: "post",
        body: JSON.stringify(id),
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${tokenStr}`,
          "Referrer-Policy": "strict-origin-when-cross-origin",
        },
      }
    );
    if (!response.ok) {
      return { status: false };
    } else {
      const data = await response.json();
      return data;
    }
  } catch (error) {
    console.error(error);
    return { status: false };
  }
};

// Patient Prescription Create
export const CreatePatientPrescription = async (prep) => {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_API_URL}${api.CreatePatientPrescription}`,
      {
        method: "post",
        body: JSON.stringify(prep),
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${tokenStr}`,
          "Referrer-Policy": "strict-origin-when-cross-origin",
        },
      }
    );
    if (!response.ok) {
      return { status: false };
    } else {
      const data = await response.json();
      return data;
    }
  } catch (error) {
    console.error(error);
    return { status: false };
  }
};

// Update Patient Prescription
export const UpdatePatientPrescription = async (prep) => {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_API_URL}${api.UpdatePatientPrescription}`,
      {
        method: "put",
        body: JSON.stringify(prep),
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${tokenStr}`,
          "Referrer-Policy": "strict-origin-when-cross-origin",
        },
      }
    );
    if (!response.ok) {
      return { status: false };
    } else {
      const data = await response.json();
      return data;
    }
  } catch (error) {
    console.error(error);
    return { status: false };
  }
};

// Delete Patient Prescription

export const DeletePatientPrescription = async (id) => {
  try {
    const res = await fetch(
      `${process.env.REACT_APP_API_URL}${api.DeletePatientPrescription}`,
      {
        method: "delete",
        body: JSON.stringify({
          id: id.toString(),
        }),
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${tokenStr}`,
        },
      }
    );
    if (!res.ok) {
      return { status: false };
    }
    const data = await res.json();
    return data;
  } catch (error) {
    // Handle the error
    console.error(error);
    return { status: false };
  }
};

// Patient Prescriptin Payment
export const AddPatientPrescriptionPayment = async (prep) => {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_API_URL}${api.AddPatientPrescriptionPayment}`,
      {
        method: "post",
        body: JSON.stringify(prep),
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${tokenStr}`,
          "Referrer-Policy": "strict-origin-when-cross-origin",
        },
      }
    );
    if (!response.ok) {
      return { status: false };
    } else {
      const data = await response.json();
      return data;
    }
  } catch (error) {
    console.error(error);
    return { status: false };
  }
};

// Patient Prescription Payment Edit

export const EditPatientPrescriptionPayment = async (prep) => {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_API_URL}${api.EditPatientPrescriptionPayment}`,
      {
        method: "post",
        body: JSON.stringify(prep),
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${tokenStr}`,
          "Referrer-Policy": "strict-origin-when-cross-origin",
        },
      }
    );
    if (!response.ok) {
      return { status: false };
    } else {
      const data = await response.json();
      return data;
    }
  } catch (error) {
    console.error(error);
    return { status: false };
  }
};

// ----------------------------------------------- listClinicPayment API ------------

export const listClinicPayment = async (list) => {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_API_URL}${api.listClinicPayment}`,
      {
        method: "post",
        body: JSON.stringify(list),
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${tokenStr}`,
        },
      }
    );
    if (!response.ok) {
      return { status: false };
    } else {
      const data = await response.json();
      return data;
    }
  } catch (error) {
    console.error(error);
    return { status: false };
  }
};

// ---------------------------------------------------- list pharmacy api -----------------------------------------------------

export const PharmacyPaymentList = async (month) => {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_API_URL}${api.ListPharmacyIncome}`,
      {
        method: "post",
        body: JSON.stringify(month),
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${tokenStr}`,
        },
      }
    );
    if (!response.ok) {
      return { status: false };
    } else {
      const data = await response.json();
      return data;
    }
  } catch (error) {
    console.error(error);
    return { status: false };
  }
};
// ----------------------------------------------- listClinicPayment API ------------

export const NetProfitList = async (list) => {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_API_URL}${api.NetProfitList}`,
      {
        method: "post",
        body: JSON.stringify(list),
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${tokenStr}`,
        },
      }
    );
    if (!response.ok) {
      return { status: false };
    } else {
      const data = await response.json();
      return data;
    }
  } catch (error) {
    console.error(error);
    return { status: false };
  }
};

// Appointment Payment List
export const AppointmentPaymentList = async (prep) => {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_API_URL}${api.AppointmentPaymentList}`,
      {
        method: "post",
        body: JSON.stringify(prep),
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${tokenStr}`,
          "Referrer-Policy": "strict-origin-when-cross-origin",
        },
      }
    );
    if (!response.ok) {
      return { status: false };
    } else {
      const data = await response.json();
      return data;
    }
  } catch (error) {
    console.error(error);
    return { status: false };
  }
};

// Patient Treatment Payment
export const TreatmentPayment = async (prep) => {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_API_URL}${api.TreatmentPayment}`,
      {
        method: "post",
        body: JSON.stringify(prep),
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${tokenStr}`,
          "Referrer-Policy": "strict-origin-when-cross-origin",
        },
      }
    );
    if (!response.ok) {
      return { status: false };
    } else {
      const data = await response.json();
      return data;
    }
  } catch (error) {
    console.error(error);
    return { status: false };
  }
};

export const pharmacyExpenseList = async (month) => {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_API_URL}${api.ListPharmacyExpenses}`,
      {
        method: "post",
        body: JSON.stringify(month),
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${tokenStr}`,
        },
      }
    );
    if (!response.ok) {
      return { status: false };
    } else {
      const data = await response.json();
      return data;
    }
  } catch (error) {
    console.error(error);
    return { status: false };
  }
};

// Inquiry and Notification

export const StoreInquiry = async (note) => {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_API_URL}${api.StoreInquiry}`,
      {
        method: "post",
        body: JSON.stringify(note),
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${tokenStr}`,
          "Referrer-Policy": "strict-origin-when-cross-origin",
        },
      }
    );
    if (!response.ok) {
      return { status: false };
    } else {
      const data = await response.json();
      return data;
    }
  } catch (error) {
    console.error(error);
    return { status: false };
  }
};

// Notication List
export const NotificationList = async (note) => {
  console.log(userId);
  try {
    const response = await fetch(
      `${process.env.REACT_APP_API_URL}${api.NotificationList}`,
      {
        method: "post",
        body: JSON.stringify(note),
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${tokenStr}`,
          "Referrer-Policy": "strict-origin-when-cross-origin",
        },
      }
    );
    if (!response.ok) {
      return { status: false };
    } else {
      const data = await response.json();
      return data;
    }
  } catch (error) {
    console.error(error);
    return { status: false };
  }
};

// Inquiry List
export const InquiryList = async (note) => {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_API_URL}${api.InquiryList}`,
      {
        method: "post",
        body: JSON.stringify(note),
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${tokenStr}`,
          "Referrer-Policy": "strict-origin-when-cross-origin",
        },
      }
    );
    if (!response.ok) {
      return { status: false };
    } else {
      const data = await response.json();
      return data;
    }
  } catch (error) {
    console.error(error);
    return { status: false };
  }
};

//Out Patient Inquiry List
// export const OpInquiry = async (note) => {
//   try {
//     const response = await fetch(
//       `${process.env.REACT_APP_API_URL}${api.OpInquiry}`,
//       {
//         method: "post",
//         body: JSON.stringify(note),
//         headers: {
//           "Content-Type": "application/json",
//           Authorization: `Bearer ${tokenStr}`,
//         'Referrer-Policy': 'strict-origin-when-cross-origin'
//         },
//       }
//     );
//     if (!response.ok) {
//       return { status: false };
//     } else {
//       const data = await response.json();
//       return data;
//     }
//   } catch (error) {
//     console.error(error);
//     return { status: false };
//   }
// };

// Change Inquiry Status
export const ChangeInStatus = async (note) => {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_API_URL}${api.ChangeInStatus}`,
      {
        method: "post",
        body: JSON.stringify(note),
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${tokenStr}`,
          "Referrer-Policy": "strict-origin-when-cross-origin",
        },
      }
    );
    if (!response.ok) {
      return { status: false };
    } else {
      const data = await response.json();
      return data;
    }
  } catch (error) {
    console.error(error);
    return { status: false };
  }
};

// Change OP notification status
// export const ChangeStatusOp = async (note) => {
//   try {
//     const response = await fetch(
//       `${process.env.REACT_APP_API_URL}${api.ChangeStatusOp}`,
//       {
//         method: "post",
//         body: JSON.stringify(note),
//         headers: {
//           "Content-Type": "application/json",
//           Authorization: `Bearer ${tokenStr}`,
//         'Referrer-Policy': 'strict-origin-when-cross-origin'
//         },
//       }
//     );
//     if (!response.ok) {
//       return { status: false };
//     } else {
//       const data = await response.json();
//       return data;
//     }
//   } catch (error) {
//     console.error(error);
//     return { status: false };
//   }
// };

// Change  notification status
export const ChangeStatus = async (note) => {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_API_URL}${api.ChangeStatus}`,
      {
        method: "post",
        body: JSON.stringify(note),
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${tokenStr}`,
          "Referrer-Policy": "strict-origin-when-cross-origin",
        },
      }
    );
    if (!response.ok) {
      return { status: false };
    } else {
      const data = await response.json();
      return data;
    }
  } catch (error) {
    console.error(error);
    return { status: false };
  }
};

// Delete Pharmacy Expense
export const PharmacyExpensesDeleteAPI = async (id) => {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_API_URL}${api.DeletePharmacyExpenses}`,
      {
        method: "delete",
        body: JSON.stringify({
          id: id.toString(),
        }),
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${tokenStr}`,
        },
      }
    );
    if (!response.ok) {
      return { status: false };
    } else {
      const data = await response.json();
      return data;
    }
  } catch (error) {
    console.error(error);
    return { status: false };
  }
};

// Edit Treatment Payment
export const EditTreatmentPayment = async (prep) => {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_API_URL}${api.EditTreatmentPayment}`,
      {
        method: "post",
        body: JSON.stringify(prep),
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${tokenStr}`,
          "Referrer-Policy": "strict-origin-when-cross-origin",
        },
      }
    );
    if (!response.ok) {
      return { status: false };
    } else {
      const data = await response.json();
      return data;
    }
  } catch (error) {
    console.error(error);
    return { status: false };
  }
};

// Create Pharmacy Expense
export const StorePharmacyExpenses = async (formData) => {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_API_URL}${api.StorePharmacyExpenses}`,
      {
        method: "post",
        body: formData,
        headers: {
          Authorization: `Bearer ${tokenStr}`,
          "Referrer-Policy": "strict-origin-when-cross-origin",
        },
      }
    );
    if (!response.ok) {
      return { status: false };
    } else {
      const data = await response.json();
      return data;
    }
  } catch (error) {
    console.error(error);
    return { status: false };
  }
};
// Update Pharmacy Expense
export const UpdatePharmacyExpenses = async (formData) => {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_API_URL}${api.UpdatePharmacyExpenses}`,
      {
        method: "post",
        body: formData,
        headers: {
          Authorization: `Bearer ${tokenStr}`,
          "Referrer-Policy": "strict-origin-when-cross-origin",
        },
      }
    );
    if (!response.ok) {
      return { status: false };
    } else {
      const data = await response.json();
      return data;
    }
  } catch (error) {
    console.error(error);
    return { status: false };
  }
};

// Accounts Others Expense
export const StoreOthersExpenses = async (formData) => {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_API_URL}${api.StoreOthersExpenses}`,
      {
        method: "post",
        body: formData,
        headers: {
          Authorization: `Bearer ${tokenStr}`,
          "Referrer-Policy": "strict-origin-when-cross-origin",
        },
      }
    );
    if (!response.ok) {
      return { status: false };
    } else {
      const data = await response.json();
      return data;
    }
  } catch (error) {
    console.error(error);
    return { status: false };
  }
};
// Update Others Expense
export const UpdateOthersExpenses = async (formData) => {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_API_URL}${api.UpdateOthersExpenses}`,
      {
        method: "post",
        body: formData,
        headers: {
          Authorization: `Bearer ${tokenStr}`,
          "Referrer-Policy": "strict-origin-when-cross-origin",
        },
      }
    );
    if (!response.ok) {
      return { status: false };
    } else {
      const data = await response.json();
      return data;
    }
  } catch (error) {
    console.error(error);
    return { status: false };
  }
};

// List Others Expenses
export const ListOthersExpenses = async (month) => {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_API_URL}${api.ListOthersExpenses}`,
      {
        method: "post",
        body: JSON.stringify(month),
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${tokenStr}`,
        },
      }
    );
    if (!response.ok) {
      return { status: false };
    } else {
      const data = await response.json();
      return data;
    }
  } catch (error) {
    console.error(error);
    return { status: false };
  }
};

// Delete Others Expenses

export const DeleteOthersExpenses = async (id) => {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_API_URL}${api.DeleteOthersExpenses}`,
      {
        method: "delete",
        body: JSON.stringify({
          id: id.toString(),
        }),
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${tokenStr}`,
        },
      }
    );
    if (!response.ok) {
      return { status: false };
    } else {
      const data = await response.json();
      return data;
    }
  } catch (error) {
    console.error(error);
    return { status: false };
  }
};

// Accounts Others Expense
export const StoreLabExpenses = async (formData) => {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_API_URL}${api.StoreLabExpenses}`,
      {
        method: "post",
        body: formData,
        headers: {
          Authorization: `Bearer ${tokenStr}`,
          "Referrer-Policy": "strict-origin-when-cross-origin",
        },
      }
    );
    if (!response.ok) {
      return { status: false };
    } else {
      const data = await response.json();
      return data;
    }
  } catch (error) {
    console.error(error);
    return { status: false };
  }
};

// Update Lab Expense
export const UpdateLabExpenses = async (formData) => {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_API_URL}${api.UpdateLabExpenses}`,
      {
        method: "post",
        body: formData,
        headers: {
          Authorization: `Bearer ${tokenStr}`,
          "Referrer-Policy": "strict-origin-when-cross-origin",
        },
      }
    );
    if (!response.ok) {
      return { status: false };
    } else {
      const data = await response.json();
      return data;
    }
  } catch (error) {
    console.error(error);
    return { status: false };
  }
};

// List Lab Expenses
export const ListLabExpenses = async (month) => {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_API_URL}${api.ListLabExpenses}`,
      {
        method: "post",
        body: JSON.stringify(month),
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${tokenStr}`,
        },
      }
    );
    if (!response.ok) {
      return { status: false };
    } else {
      const data = await response.json();
      return data;
    }
  } catch (error) {
    console.error(error);
    return { status: false };
  }
};

// Delete Lab Expenses

export const DeleteLabExpenses = async (id) => {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_API_URL}${api.DeleteLabExpenses}`,
      {
        method: "delete",
        body: JSON.stringify({
          id: id.toString(),
        }),
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${tokenStr}`,
        },
      }
    );
    if (!response.ok) {
      return { status: false };
    } else {
      const data = await response.json();
      return data;
    }
  } catch (error) {
    console.error(error);
    return { status: false };
  }
};


// Accounts Inventory Expense
export const StoreExpenses = async (formData) => {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_API_URL}${api.StoreExpenses}`,
      {
        method: "post",
        body: formData,
        headers: {
          Authorization: `Bearer ${tokenStr}`,
          "Referrer-Policy": "strict-origin-when-cross-origin",
        },
      }
    );
    if (!response.ok) {
      return { status: false };
    } else {
      const data = await response.json();
      return data;
    }
  } catch (error) {
    console.error(error);
    return { status: false };
  }
};

// Update Inventory Expense
export const UpdateExpenses = async (formData) => {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_API_URL}${api.UpdateExpenses}`,
      {
        method: "post",
        body: formData,
        headers: {
          Authorization: `Bearer ${tokenStr}`,
          "Referrer-Policy": "strict-origin-when-cross-origin",
        },
      }
    );
    if (!response.ok) {
      return { status: false };
    } else {
      const data = await response.json();
      return data;
    }
  } catch (error) {
    console.error(error);
    return { status: false };
  }
};

// List Inventory Expenses
export const ListExpenses = async (month) => {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_API_URL}${api.ListExpenses}`,
      {
        method: "post",
        body: JSON.stringify(month),
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${tokenStr}`,
        },
      }
    );
    if (!response.ok) {
      return { status: false };
    } else {
      const data = await response.json();
      return data;
    }
  } catch (error) {
    console.error(error);
    return { status: false };
  }
};

// Delete Inventory Expenses

export const DeleteExpenses = async (id) => {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_API_URL}${api.DeleteExpenses}`,
      {
        method: "delete",
        body: JSON.stringify({
          id: id.toString(),
        }),
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${tokenStr}`,
        },
      }
    );
    if (!response.ok) {
      return { status: false };
    } else {
      const data = await response.json();
      return data;
    }
  } catch (error) {
    console.error(error);
    return { status: false };
  }
};

// List Consultant Payments
export const ListConsultantExpenses = async (month) => {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_API_URL}${api.ListConsultantExpenses}`,
      {
        method: "post",
        body: JSON.stringify(month),
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${tokenStr}`,
        },
      }
    );
    if (!response.ok) {
      return { status: false };
    } else {
      const data = await response.json();
      return data;
    }
  } catch (error) {
    console.error(error);
    return { status: false };
  }
};
// Store Consultant Payment
export const StoreConsultantPayment = async (month) => {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_API_URL}${api.StoreConsultantPayment}`,
      {
        method: "post",
        body: JSON.stringify(month),
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${tokenStr}`,
        },
      }
    );
    if (!response.ok) {
      return { status: false };
    } else {
      const data = await response.json();
      return data;
    }
  } catch (error) {
    console.error(error);
    return { status: false };
  }
};

// Update Consultant Payment
export const UpdateConsultantPayment = async (month) => {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_API_URL}${api.UpdateConsultantPayment}`,
      {
        method: "post",
        body: JSON.stringify(month),
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${tokenStr}`,
        },
      }
    );
    if (!response.ok) {
      return { status: false };
    } else {
      const data = await response.json();
      return data;
    }
  } catch (error) {
    console.error(error);
    return { status: false };
  }
};


// List Salary|

export const ListSalary = async (month) => {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_API_URL}${api.ListSalary}`,
      {
        method: "post",
        body: JSON.stringify(month),
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${tokenStr}`,
        },
      }
    );
    if (!response.ok) {
      return { status: false };
    } else {
      const data = await response.json();
      return data;
    }
  } catch (error) {
    console.error(error);
    return { status: false };
  }
};

// Delete Salary

export const DeleteSalary = async (id, type) => {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_API_URL}${api.DeleteSalary}`,
      {
        method: "delete",
        body: JSON.stringify({
          id: id.toString(),
          type: type,
        }),
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${tokenStr}`,
        },
      }
    );
    if (!response.ok) {
      return { status: false };
    } else {
      const data = await response.json();
      return data;
    }
  } catch (error) {
    console.error(error);
    return { status: false };
  }
};

// Add Doctor Salary

export const StoreDoctorSalary = async (salary) => {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_API_URL}${api.StoreDoctorSalary}`,
      {
        method: "post",
        body: JSON.stringify(salary),
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${tokenStr}`,
        },
      }
    );
    if (!response.ok) {
      return { status: false };
    } else {
      const data = await response.json();
      return data;
    }
  } catch (error) {
    console.error(error);
    return { status: false };
  }
};
// Add Staff Salary

export const StoreStaffSalary = async (salary) => {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_API_URL}${api.StoreStaffSalary}`,
      {
        method: "post",
        body: JSON.stringify(salary),
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${tokenStr}`,
        },
      }
    );
    if (!response.ok) {
      return { status: false };
    } else {
      const data = await response.json();
      return data;
    }
  } catch (error) {
    console.error(error);
    return { status: false };
  }
};


// Update Salary
export const UpdateSalary = async (salary) => {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_API_URL}${api.UpdateSalary}`,
      {
        method: "put",
        body: JSON.stringify(salary),
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${tokenStr}`,
        },
      }
    );
    if (!response.ok) {
      return { status: false };
    } else {
      const data = await response.json();
      return data;
    }
  } catch (error) {
    console.error(error);
    return { status: false };
  }
};

// Profile Update

export const ProfileUpdate = async (salary) => {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_API_URL}${api.ProfileUpdate}`,
      {
        method: "post",
        body: JSON.stringify(salary),
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${tokenStr}`,
        },
      }
    );
    if (!response.ok) {
      return { status: false };
    } else {
      const data = await response.json();
      return data;
    }
  } catch (error) {
    console.error(error);
    return { status: false };
  }
};

//Change Password
export const ProfileChangePassword = async (pass) => {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_API_URL}${api.ProfileChangePassword}`,
      {
        method: "post",
        body: JSON.stringify(pass),
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${tokenStr}`,
        },
      }
    );
    if (!response.ok) {
      return { status: false };
    } else {
      const data = await response.json();
      return data;
    }
  } catch (error) {
    console.error(error);
    return { status: false };
  }
};


// Forget Password

export const ForgetPassword = async (pass) => {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_API_URL}${api.ForgetPassword}`,
      {
        method: "post",
        body: pass,
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    if (!response.ok) {
      return { status: false };
    } else {
      const data = await response.json();
      return data;
    }
  } catch (error) {
    console.error(error);
    return { status: false };
  }
};
// 
export const ForgetVerfiyOtp = async (pass) => {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_API_URL}${api.ForgetVerfiyOtp}`,
      {
        method: "post",
        body: pass,
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    if (!response.ok) {
      return { status: false };
    } else {
      const data = await response.json();
      return data;
    }
  } catch (error) {
    console.error(error);
    return { status: false };
  }
};
// CHange Password
export const ForgetChangePassword = async (pass) => {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_API_URL}${api.ForgetChangePassword}`,
      {
        method: "post",
        body: pass,
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    if (!response.ok) {
      return { status: false };
    } else {
      const data = await response.json();
      return data;
    }
  } catch (error) {
    console.error(error);
    return { status: false };
  }
};

// 
export const PatientRegistration = async (patient) => {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_API_URL}${api.PatientRegistration}`,
      {
        method: "post",
        body: JSON.stringify(patient),
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    if (!response.ok) {
      return { status: false };
    } else {
      const data = await response.json();
      return data;
    }
  } catch (error) {
    console.error(error);
    return { status: false };
  }
};

// User Management 

export const ReadRole = async () => {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_API_URL}${api.ReadRole}`,
      {
        method: "get",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${tokenStr}`,
        },
      }
    );
    if (!response.ok) {
      return { status: false };
    } else {
      const data = await response.json();
      return data;
    }
  } catch (error) {
    console.error(error);
    return { status: false };
  }
};

// Create permission

export const CreateRolePermission = async (formdata) => {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_API_URL}${api.CreateRolePermission}`,
      {
        method: "post",
        body: JSON.stringify(formdata),
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${tokenStr}`,
        },
      }
    );
    if (!response.ok) {
      return { status: false };
    } else {
      const data = await response.json();
      return data;
    }
  } catch (error) {
    console.error(error);
    return { status: false };
  }
};

// View Permission
export const ReadRolePermission = async (formdata, token) => {

  console.log(token)
  const finalToken = token || tokenStr;
  try {
    const response = await fetch(
      `${process.env.REACT_APP_API_URL}${api.ReadRolePermission}`,
      {
        method: "post",
        body: JSON.stringify(formdata),
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${finalToken}`,
        },
      }
    );
    if (!response.ok) {
      return { status: false };
    } else {
      const data = await response.json();
      return data;
    }
  } catch (error) {
    console.error(error);
    return { status: false };
  }
};